/** @format */

export async function objectSchedule(ctx) {
  try {
    let params = { name: 'geFutureCashIncomeObjects' };
    let res = await ctx.$axios.post('/report_sql', params);

    const objects = res.data.data;
    let schedule = {};
    let o_id = [];
    let c_id = [-1];
    let i_id = [-1];

    for (let i = 0; i < objects.length; i++) {
      const o = objects[i];
      const s = o.planning_income_data;

      o_id.push(o.id);
      if (o.is_investor) i_id.push(o.investor_id);
      else c_id.push(o.client_id);

      schedule[o.id] = { plan: s };
    }

    params = {
      name: 'geFutureCashIncomeOrders',
      params: { o_id, c_id, i_id },
    };

    res = await ctx.$axios.post('/report_sql', params);
    let cash = res.data.data;

    const daysForward = ctx.getParam('futureCashInOut_days') || 30;

    const result = analyzeExpectedPayments({
      schedule,
      cash,
      monthsForward: daysForward / 30,
    });

    ctx.data = result;
  } catch (e) {
    console.error(e);
  }
}

export function analyzeExpectedPayments({ schedule, cash, monthsForward = 3 }) {
  const today = new Date().toISOString().slice(0, 10);

  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + monthsForward);
  const endISO = endDate.toISOString().slice(0, 10);

  const result = [];

  Object.entries(schedule).forEach(([object_id, obj]) => {
    const plans = [...(obj.plan || [])]
      .map((p) => ({
        old_date: p.date_plan,
        value: p.value,
      }))
      .sort((a, b) => a.old_date.localeCompare(b.old_date));

    let paidTotal = cash.filter((c) => c.object_id == object_id && c.status === 2).reduce((s, c) => s + c.value, 0);

    plans.forEach((plan) => {
      if (plan.old_date > endISO) return;

      if (paidTotal >= plan.value) {
        paidTotal -= plan.value;
        return;
      }

      const remaining = plan.value - paidTotal;
      paidTotal = 0;

      const color = plan.old_date < today ? 'red' : null;

      result.push({
        old_date: plan.old_date,
        plan_date: plan.old_date,
        object_id: Number(object_id),
        value: remaining,
        color,
      });
    });
  });

  return result.sort((a, b) => a.plan_date.localeCompare(b.plan_date));
}
